module.exports = __webpack_public_path__ + "img/arrow_from.161d32cd.png";